import moment, { Moment } from 'moment';
import { getTimezonesWithOffsets } from './get-timezones-with-offset';

export function momentTimezone(
  dateString: string | undefined | Date | Moment,
  timezone: string,
): Moment {
  const timezones = getTimezonesWithOffsets();
  const offset = timezones.find((tz) => tz.name === timezone)?.offset ?? 0;
  // Parse the date string into a Moment object
  const date = moment(dateString);

  // Convert the offset from minutes to hours
  const offsetInHours = offset / 60;

  // Format the date in the specific timezone using the offset
  return date.utcOffset(offsetInHours);
}
